/**
 * Utility functions for authentication-related logic
 */

/**
 * Checks if the current pathname is a High School authentication route
 * @param pathname - The current location pathname
 * @returns true if the path is /high-school/signup or /high-school/login
 */
export const isHighSchoolAuthRoute = (pathname: string): boolean => {
  return pathname.startsWith('/high-school/signup') || pathname.startsWith('/high-school/login');
};

export const isHighSchoolSectionRoute = (pathname: string): boolean => (
  pathname.startsWith('/high-school') ||
  pathname.startsWith('/waec') ||
  pathname.startsWith('/jamb') ||
  pathname.startsWith('/mock-test') ||
  pathname.startsWith('/school-work')
);